module.exports = __webpack_public_path__ + "static/img/headerbf9a950.png";